import { render } from "./genreComponent.vue?vue&type=template&id=63c4ebe3&scoped=true"
import script from "./genreComponent.vue?vue&type=script&lang=js"
export * from "./genreComponent.vue?vue&type=script&lang=js"

import "./genreComponent.vue?vue&type=style&index=0&id=63c4ebe3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63c4ebe3"]])

export default __exports__